module.exports = __webpack_public_path__ + "static/media/gris1.7e7cf875.jpg";